var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.287915 11.9881L4.1071 7.4297L0.287914 2.87132C-0.0959727 2.41314 -0.0959728 1.67299 0.287914 1.2148C0.671801 0.756611 1.29193 0.756611 1.67581 1.2148L6.19387 6.60732C6.57776 7.0655 6.57776 7.80565 6.19387 8.26384L1.67581 13.6564C1.29193 14.1145 0.671802 14.1145 0.287915 13.6564C-0.0861286 13.1982 -0.0959719 12.4463 0.287915 11.9881Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.bfb7ece815cd51ea1ab725971d706d71.svg";
export { ForwardRef as ReactComponent };